// extracted by mini-css-extract-plugin
module.exports = {"linkableItem":"style_linkableItem__1k4e3"};